import { render, staticRenderFns } from "./questionDetail.vue?vue&type=template&id=945fb2fe&scoped=true&"
import script from "./questionDetail.js?vue&type=script&lang=js&"
export * from "./questionDetail.js?vue&type=script&lang=js&"
import style0 from "./questionDetail.css?vue&type=style&index=0&id=945fb2fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945fb2fe",
  null
  
)

export default component.exports